module.exports = __webpack_public_path__ + "img/wti-banner.e6712526.jpg";